import { createInstance, setLogLevel, setLogger } from '@optimizely/react-sdk'

export const optimizelyClient = createInstance({
  sdkKey: process.env.OPTIMIZELY_SDK_KEY,
  eventBatchSize: 10,
  eventFlushInterval: 1000
})

export const optimizelyLogConfig = () => {
  setLogLevel(0)
  setLogger(null)
}
